
import Vue  from 'vue'
import ContextMenu from './shared/ContextMenu.vue';
//import { DentalConditionType } from '../../types/Sapphire_dto'
// import DeleteReasonPopup, { DeleteReasonPopupRef } from './shared/DeleteReasonPopup.vue';
//import PSPDFKitContainer from './shared/PSPDFKitContainer.vue';
//import '../../css/screen.css';
// import EHRClinicalReportPopup, { EHRClinicalReportPopupRef } from './shared/EHRClinicalReportPopup.vue';

export default Vue.extend({
  name: 'PlaygroundApp',
  components: {
      // EHRClinicalReportPopup,
      ContextMenu,
  },
  computed: {
    // ClinicalReportPopup(): EHRClinicalReportPopupRef {
    //     return this.$refs.EHRClinicalReportPopupVueComponent as EHRClinicalReportPopupRef;
    // },
  },
  data() {
    return {
      patientID: 4180,
      // pdfFile: this.pdfFile || "/Dental - Toothache Protocol 2.pdf",
    };
  },
  watch: {

  },
  methods: {
    handleLoaded(instance) {
      console.log("PSPDFKit has loaded: ", instance);
      // Do something.
    },
    viewConditions() {
      console.log('In View Conditions!');
    },
    viewNotes() {
      console.log('In View Notes!');
    },
    addQuickNote() {
      console.log('In Add Quick Note!');
    },
    selectRemainingTeeth(parameterString: String) {
      let parameters = parameterString.split('|');
      console.log('In selectRemainingTeeth! Begin=' + parameters[0].toString() + ': End=' + parameters[1].toString());
    },
    addCondition(parameterString: String) {
      let parameters = parameterString.split('|');
      console.log('In AddCondition! ', 'condID=' + parameters[0].toString() + ': SurfaceID=' + parameters[1].toString() );

        //this.$emit("addCommonCondition", cond, surface);
    },
    // showPopup(){
    //   this.ClinicalReportPopup.patientID=this.patientID;
    //   this.ClinicalReportPopup.showPopup();      
    // }
  },
});

